export default function sendEvent(id, cfid, window) {
    const event = new window.CustomEvent('lfidDataReceived', { detail: { lfid: id, cfid } });
    window.dispatchEvent(event);
}
